<script>
	import Navbar from './components/Navbar.svelte';
	import Map from './components/Map.svelte';
</script>

<div class="app">
	<Navbar />
	<Map />
</div>

<style>
.app {
  text-align: center;
}
</style>